import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'flo-image-overlay',
  styleUrls: ['./image-overlay.component.scss'],
  templateUrl: './image-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageOverlayComponent {
  @Input() public imgSrc: string
  @Input() public imgAlt: string
  @Input() public gradient: 'none' | 'top' | 'full' | 'bottom' = 'none'
  @Input() public contentPosition: '' | 'center'
}
